import React from 'react'
import Canvas from './Canvas'

function App() {

  return <Canvas key="headed_grid_canvas"/>
}

export default App
